export default __webpack_public_path__ + "media/images/brands/expmessenger/other/mission-762ef0f4f40b2511f5838f6c995f9037.jpg";